import Loading from '@Web/Src/UI/Loading';
import SectionHeader from '@Web/Src/Components/SectionHeader';

const RoiLazy = () => {
    return (
        <div className='mt-32 w-full'>
            <SectionHeader
                type='dark'
                className='mx-auto mt-24'
                icon='roi'
                title={__('What’s the ROI of our referral platform?')}
                desc={__(
                    'Get up to 30% more leads every year with referral tracking software. All you need to do is launch a referral program. Consumers are 3x more likely to choose you when referred, making referral software a powerful growth tool.'
                )}
            />

            <div className='flex w-full items-center justify-center'>
                <Loading />
            </div>
        </div>
    );
};

export default RoiLazy;
